import { Button } from "@/components/ui/button";
import { ShoppingCart } from "lucide-react";

interface TotalCalculatorProps {
  total: number;
  itemCount: number;
}

export function TotalCalculator({ total, itemCount }: TotalCalculatorProps) {
  const scrollToForm = () => {
    const formElement = document.getElementById('order-form');
    if (formElement) {
      formElement.scrollIntoView({ behavior: window.matchMedia("(prefers-reduced-motion: reduce)").matches ? 'auto' : 'smooth', block: 'start' });
    }
  };

  if (itemCount === 0) return null;

  return (
    <div className="cart-bar fixed bottom-0 left-0 right-0 z-50">
      <div className="site-container py-4">
        <div className="flex items-center justify-between gap-4">
          <div className="flex items-center gap-4 min-w-0">
            <ShoppingCart className="w-6 h-6 text-primary hidden sm:block" />
            <div>
              <p className="text-sm text-muted-foreground">
                {itemCount} {itemCount === 1 ? 'Produkt' : 'Produkte'} ausgewählt
              </p>
              <p className="product-price" aria-live="polite" data-testid="text-total">
                CHF {total.toFixed(2)}
              </p>
            </div>
          </div>
          <Button
            onClick={scrollToForm}
            size="lg"
            variant="secondary"
            className="px-4 sm:px-8"
            data-testid="button-proceed-order"
          >
            Zur Bestellung
          </Button>
        </div>
      </div>
    </div>
  );
}
